// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Dollar = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5 2.5h-1v1.705c-1.458.157-2.577 1.033-2.577 2.626 0 1.712 1.304 2.233 2.577 2.549v3.248c-.936-.216-1.709-.884-1.719-2.105H5.585c.057 1.941 1.412 2.94 2.915 3.163V15.5h1v-1.779c1.549-.116 2.871-1.029 2.871-2.665 0-1.764-1.54-2.21-2.871-2.514V5.226c.874.131 1.486.646 1.519 1.579h1.144C12.105 5.252 10.966 4.37 9.5 4.207zm-1 2.735c-.841.14-1.472.635-1.472 1.544 0 .928.646 1.284 1.472 1.52zm1 4.384v3.075c.986-.087 1.701-.63 1.701-1.508 0-.971-.856-1.341-1.701-1.567"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(Dollar);
export default ForwardRef;
